import { html } from "htm/preact";
import { useState } from "preact/hooks";

export default function NewsletterCompact({
  lang,
  signUpText,
  successMessage,
  errorMessage,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // null, 'success', or 'error'

  const handleSubmit = (event) => {
    event.preventDefault();

    const myForm = event.target;
    const formData = new FormData(myForm);

    setIsSubmitting(true);
    setSubmitStatus(null);

    fetch("/api/add-subscriber/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: formData.get("email"),
        language: lang,
        bzzz: formData.get("bzzz"),
      }),
    })
      .then((response) => {
        setIsSubmitting(false);
        if (response.ok) {
          setSubmitStatus("success");
          myForm.reset();
        } else {
          setSubmitStatus("error");
        }
      })
      .catch((error) => {
        console.error("Newsletter form error:", error);
        setIsSubmitting(false);
        setSubmitStatus("error");
      });
  };

  return html`
    <form
      method="POST"
      onSubmit=${handleSubmit}
      class="w-full max-w-2xl flex flex-col gap-2"
    >
      <p class="hidden">
        <label>
          <input
            id="bzzz"
            name="bzzz"
            type="text"
            tabindex="-1"
            autocomplete="off"
          />
        </label>
      </p>

      <div class="w-full">
        <label class="sr-only block" for="email-newsletter"> Email </label>
        <div class="flex flex-row">
          <input
            class="appearance-none block w-full rounded-l-md text-zinc-300 bg-zinc-900 border border-r-transparent border-zinc-700 py-3 px-4 leading-tight focus:outline-none focus:border-zinc-400 focus:ring-0 placeholder:text-zinc-500"
            id="email-newsletter"
            name="email"
            type="email"
            placeholder="email@example.com"
            required
          />
          <button
            type="submit"
            disabled=${isSubmitting}
            class="w-full max-w-fit rounded-r-md lg:max-w-40 cursor-pointer transition p-4 border border-zinc-700 backdrop-blur-sm bg-zinc-900 text-zinc-300 after:content-['→'] md:after:pl-1 hover:border-zinc-400 lg:px-6 lg:py-5 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span class="sr-only md:not-sr-only"
              >${isSubmitting ? "..." : signUpText}</span
            >
          </button>
        </div>
      </div>

      ${submitStatus === "success" &&
      html`
        <div class="w-full">
          <p class="text-sm text-center text-green-400">${successMessage}</p>
        </div>
      `}
      ${submitStatus === "error" &&
      html`
        <div class="w-full">
          <p class="text-sm text-center text-red-400">${errorMessage}</p>
        </div>
      `}
    </form>
  `;
}
